import config from './../config';

export default {
  name: 'enfants',
  data () {
    return {
        startX: 0,
        startY: 0,
        initialMouseX: 0,
        initialMouseY: 0,
        isEnd: false,
        cible: null,
        nbTimes: 0,
        dragIndex: 0
      }
  },
  methods: {
    mousemoveWindow: function(e) {
      const tooltipSpan = this.$el.querySelector(".enceinte-tooltip");
      var x = e.clientX;
      var y = e.clientY;
      tooltipSpan.style.top = (y + 20) + 'px';
      tooltipSpan.style.left = (x + 20) + 'px';
    },
    overItem: function(event) {
      const tooltipSpan = this.$el.querySelector(".enceinte-tooltip");
      tooltipSpan.classList.add("enceinte-tooltip--on");
      tooltipSpan.innerHTML = this.retrieveName(event.target.getAttribute("data-id"));
    },
    outItem: function(event) {
      const tooltipSpan = this.$el.querySelector(".enceinte-tooltip");  
      tooltipSpan.classList.remove("enceinte-tooltip--on");
    },
    dragStart: function(event) {
      event.preventDefault();
      this.cible = event.target;
      this.dragIndex += 1;
      this.cible.style.zIndex = this.dragIndex;
      this.startX = this.cible.offsetLeft;
      this.startY = this.cible.offsetTop;
      this.initialMouseX = event.clientX;
      this.initialMouseY = event.clientY;
      document.addEventListener('mousemove', this.mousemove);
      document.addEventListener('mouseup', this.mouseup);
    },
    mousemove: function(event) {
      var dx = event.clientX - this.initialMouseX;
      var dy = event.clientY - this.initialMouseY;
      let tmpY = this.startY + dy;
      let tmpX = this.startX + dx;
      this.cible.style.top = tmpY + 'px';
      this.cible.style.left = tmpX + 'px';
      // Scale bag or kit on rollover
      const bag = document.querySelector('.containers-bag')
      const kit = document.querySelector('.containers-kit')
      if(this.isClose(tmpY, tmpX, 270, 640)) {
        bag.classList.add('active')
      } else {
        bag.classList.remove('active')
      }
      if(this.isClose(tmpY, tmpX, -22, 667)) {
        kit.classList.add('active')
      } else {
        kit.classList.remove('active')
      }
    },
    mouseup: function(event) {
      document.removeEventListener('mousemove', this.mousemove);
      document.removeEventListener('mouseup', this.mouseup);
      let id = this.cible.getAttribute("data-id");
      let tmpX = this.cible.style.top;
      let tmpY = this.cible.style.left;
      if(this.isClose(tmpX, tmpY, 270, 540)) {
        let result = this.openPopinResult(this.cible.getAttribute("data-id"), this.cible.getAttribute("src"), 1);
        this.moveItem(this.cible, result);
      } else if(this.isClose(tmpX, tmpY, -22, 567)) {
        let result = this.openPopinResult(this.cible.getAttribute("data-id"), this.cible.getAttribute("src"), 0);
        this.moveItem(this.cible, result);
      } else {
        TweenLite.to(this.cible, 0.5, { left:this.startX, top:this.startY, ease:Quad.easeOut });
      }
    },
    moveItem: function(cible, result) {
      if(result == "1") TweenLite.to(cible, 1, { left:530, top:260, opacity:0.3, scale:0.6, ease:Quad.easeOut });
      if(result == "2") TweenLite.to(cible, 1, { left:550, top:0, opacity:0.3, scale:0.6, ease:Quad.easeOut });
      if(result == "3") {
        cible.classList.add("enceinte-item--forbidden");
        TweenLite.to(cible, 1, { opacity:0, scale:0, ease:Quad.easeOut });
      }
      cible.classList.add("item--disable");
    },
    isClose: function(mouseX, mouseY, correctX, correctY) {
      mouseX = parseInt(mouseX, 10);
      mouseY = parseInt(mouseY, 10);
      let decal = 150;
      if(mouseX > correctX-decal && mouseX < correctX+decal && mouseY > correctY-decal && mouseY < correctY+decal) {
        return true;
      } else {
        return false;
      }
    },
    closePopin: function() {
      this.closePopinMixin();
    }
  },
  mounted: function() {
    window.addEventListener('mousemove', this.mousemoveWindow);
    config.current = 1;
    this.commonIntro();
  }
}


// WEBPACK FOOTER //
// ./src/components/enfants.js